import { useState } from "react";
import { toast } from "sonner";
import { TextField, TextArea, SelectField } from "./fields";
import { submitLead } from "../../lib/api";

const HELP = [
  "AI & Machine Learning",
  "Data & Analytics",
  "Cloud & DevOps",
  "Software Development",
  "Engineering Staffing",
  "IT Staffing",
  "Semiconductor Staffing",
  "Healthcare Staffing",
  "Other",
];

const INDUSTRIES = [
  "Healthcare & Life Sciences",
  "Banking & Financial Services",
  "Manufacturing & Industrial",
  "Semiconductor & Electronics",
  "Engineering & Technology",
  "Logistics & Supply Chain",
  "Automotive & Mobility",
  "Energy & Utilities",
  "Telecommunications",
  "Retail & E-Commerce",
  "Government & Public Sector",
  "Other",
];

const initial = {
  first_name: "", last_name: "", company: "", email: "",
  phone: "", industry: "", help_with: "", message: "",
};

export default function ContactForm() {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);
  const set = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitLead(form);
      toast.success("Message sent", {
        description: "Thanks — an AMVI expert will be in touch shortly.",
      });
      setForm(initial);
    } catch (err) {
      toast.error("Something went wrong", { description: "Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
      <div className="grid gap-5 sm:grid-cols-2">
        <TextField label="First Name" name="first_name" required value={form.first_name} onChange={set} testId="contact-first-name" />
        <TextField label="Last Name" name="last_name" required value={form.last_name} onChange={set} testId="contact-last-name" />
      </div>
      <div className="grid gap-5 sm:grid-cols-2">
        <TextField label="Company" name="company" value={form.company} onChange={set} testId="contact-company" />
        <TextField label="Business Email" name="email" type="email" required value={form.email} onChange={set} testId="contact-email" />
      </div>
      <div className="grid gap-5 sm:grid-cols-2">
        <TextField label="Phone" name="phone" value={form.phone} onChange={set} testId="contact-phone" />
        <SelectField label="Industry" name="industry" value={form.industry} onChange={set} options={INDUSTRIES} testId="contact-industry" />
      </div>
      <SelectField label="What Can We Help With?" name="help_with" value={form.help_with} onChange={set} options={HELP} testId="contact-help" />
      <TextArea label="Message" name="message" required rows={5} value={form.message} onChange={set} testId="contact-message" />
      <button
        type="submit"
        disabled={loading}
        className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-sky-400 px-6 py-4 text-sm font-medium text-ink-900 transition-colors hover:bg-sky-300 disabled:opacity-60 sm:w-auto sm:px-10"
        data-testid="contact-submit"
      >
        {loading ? "Sending..." : "Talk to an AMVI Expert"}
      </button>
    </form>
  );
}
